import { AxiosStatic } from 'axios';
import axiosRetry from 'axios-retry';

export const addAxiosRetry = (axios: AxiosStatic) =>
  axiosRetry(axios, {
    retries: 3,
    retryCondition: (e) =>
      e.response === undefined || e.response?.status >= 499,
    retryDelay: (retryCount) => Math.pow(2, retryCount) * 1000,
  });
